import Vue from 'vue';

export const prepareOptionModifiersChoices = (productModifiers) => {
  try {
    const productModifierOptions = Object.values(productModifiers);
    return (productModifierOptions
      .reduce((acc: any, optionModifiers: any | number) => {
        if (typeof optionModifiers === 'number') {
          acc.push(optionModifiers);
        } else {
          Object.values(optionModifiers || {}).forEach((choices) => {
            if (choices) {
              if (choices instanceof Array) {
                acc.push(...choices);
              } else {
                acc.push(choices);
              }
            }
          })
        }
        return acc;
      }, []) as any)
      .join(',');
  } catch (error) {
    Vue.$log.error(error);
  }
}

export const getSelectedProductChoicesDisplay = (product: BasketProduct) => {
  const result: Map<string, SelectedChoice> = new Map();
  if (product.choices) {
    let productIndex = 0;
    let productName = '';
    let productChoices = '';
    product.choices.map((value, index) => {
      if (value.indent === 0) {
        productIndex = index;
        productName = value.name;
        productChoices = '';
      } else {
        if (productChoices) {
          productChoices += value.cost > 0 ? `, ${value.name} +$${value.cost.toFixed(2)}` : `, ${value.name}`;
        } else {
          productChoices = value.cost > 0 ? `${value.name} +$${value.cost.toFixed(2)}` : value.name;
        }
      }

      if (productName) {
        result.set(productIndex.toString(), { productName, productChoices });
      }
    })
  }
  return result;
}

export const validateProduct = (activeProMods, userInputs) => {
  return activeProMods.reduce((acc, apm: ProductModifier) => {
    const userProMods = userInputs[apm.id];
    if (!userProMods) {
      acc.push(new Error(`Please Choose a ${apm.description}`));
    }
    return acc;
  }, []);
}

export const productImagePath = (product: Product) => {
  const fileName = product?.desktopImageUrl;
  if (!fileName) {
    return null;
  }
  return `${fileName}`;
}
